import { MarriageDetailAnscNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchMarriageNonResidentDetailNotificationsCivilStatusShared from 'shell/components/shared/ansc-notifications/research-marriage-non-resident/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchMarriageNonResidentDetailNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageNonResidentDetailNotificationsCivilStatusShared
        scope={IdAmbito.Cancellazioni}
        items={MarriageDetailAnscNotificationsNonResidentCancellationsCrumbs()}
      />
    </Fragment>
  );
};

ResearchMarriageNonResidentDetailNotificationsCivilStatusPage.displayName =
  'Research Marriage Detail Notifications CivilStatusPage component';

export default ResearchMarriageNonResidentDetailNotificationsCivilStatusPage;
